const Site = {
  build,
};

function build() {
  return {
    __typename: "Site",
    externalAccountUuid: "",
    externalId: "",
    name: "",
    settings: JSON.stringify({}),
    startOfDay: "12:00 AM",
  };
}

export default Site;
